let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dK1g3")).then(() => parcelRequire('23ELX'));